var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "mpscontainer studip-msp-vue",
    },
    [
      _c(
        "form",
        {
          staticClass: "default",
          attrs: {
            method: "post",
          },
          on: {
            submit: function submit($event) {
              $event.preventDefault()
              return _vm.search.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "label",
            {
              staticClass: "with-action",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm",
                  },
                ],
                ref: "searchInputField",
                staticStyle: {
                  width: "260px",
                },
                attrs: {
                  type: "text",
                  placeholder: _vm.$gettext("Suchen"),
                },
                domProps: {
                  value: _vm.searchTerm,
                },
                on: {
                  input: function input($event) {
                    if ($event.target.composing) return
                    _vm.searchTerm = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "msp-btn",
                  attrs: {
                    href: "#",
                    title: _vm.$gettext("Suche starten"),
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.search.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "search",
                      role: "clickable",
                      size: "16",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "msp-btn",
                  attrs: {
                    href: "#",
                    title: _vm.$gettext("Suche zurücksetzen"),
                  },
                  on: {
                    click: function click($event) {
                      $event.preventDefault()
                      return _vm.resetSearch.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("studip-icon", {
                    attrs: {
                      shape: "decline",
                      role: "clickable",
                      size: "16",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("select", {
            attrs: {
              multiple: "multiple",
              id: _vm.select_box_id,
              name: "selectbox[]",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }